import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'react-overlay-loader';
import xosphereLogo from '../../assets/images/xosphere-logo.png';
import * as actions from '../../store/actions';
import Error from '../../components/UI/Error';
import Status from '../../components/UI/Status';

class ForgotPassword extends Component {
    state = {
        email: "",
    };

    handleEmailChange = (event) => {
      this.setState({email: event.target.value.trim()})
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onForgotPassword(this.state.email)
    };

    handleKeyPress = (event) => {
        if(event.key === 'Enter') {
            event.preventDefault();
            this.props.onForgotPassword(this.state.email)
        }
    };

    render() {
        return (
            <div className="container-fluid">
                <Loader fullPage={true} loading={this.props.loading}/>
                <div className="row justify-content-md-center">
                    <div className="col-lg-10 col-md-12 text-center">
                        <div className="row justify-content-sm-center login-top">
                            <div className="col-lg-4 col-md-5 col-sm-7 text-center"><img
                                src={xosphereLogo}
                                alt="" title=""
                                className="mb-4"/>
                                <Status statusMsg={this.props.status} divClass="col-lg-5 col-sm-6 col-center"/>
                                <Error errorMsg={this.props.error} divClass="col-lg-5 col-sm-6 col-center"/>
                                <div className="form-group mb-4">
                                    <input type="text" className="form-control" placeholder="Email Address" value={this.state.email} onChange={this.handleEmailChange} onKeyPress={e => this.handleKeyPress(e)}/>
                                </div>
                                <div className="form-group">
                                    <input type="submit" value="Reset Password" className="btn btn-primary" onClick={this.handleSubmit}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.forgotPassword.loading,
        error: state.forgotPassword.error,
        status: state.forgotPassword.status,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onForgotPassword: (email) => dispatch(actions.forgotPassword(email))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)